import React, { useState } from 'react';
import ModalDialog from '../../../shared/components/modal/ModalDialog';
import { useTranslation } from 'react-i18next';
import { Button, ButtonSize, ButtonTheme } from '../../../shared/common/Button';

type Props = {
    readonly show: boolean;
    readonly onCancel: () => void;
    readonly onImport: (isbnText: string) => Promise<void>;
    readonly isLoading: boolean;
};

export const ImportIsbnDialog = ({ onImport, show, onCancel, isLoading }: Props) => {
    const [isbnText, setIsbnText] = useState('');
    const { t } = useTranslation();

    function handleOnImport() {
        onImport(isbnText).then(() => setIsbnText(''));
    }

    return (
        <ModalDialog show={show} title={t('isbn.importIsbns')} titleClassName="bulk-isbn-header">
            <textarea
                className="bulk-isbn-textarea"
                placeholder={t('isbn.insertIsbns')}
                value={isbnText}
                onChange={event => setIsbnText(event.target.value)}
            />
            <div className="dlb-actions">
                <Button
                    onClick={onCancel}
                    text={t('cancel')}
                    theme={ButtonTheme.POSITIVE_INVERT}
                    size={ButtonSize.LARGE}
                    className="cancel-button"
                    disabled={isLoading}
                />
                <Button
                    onClick={handleOnImport}
                    text={t('isbn.import')}
                    className="proceed-button"
                    size={ButtonSize.LARGE}
                    disabled={isLoading || isbnText.length < 13}
                    isLoading={isLoading}
                />
            </div>
        </ModalDialog>
    );
};
